import { computed, ref, toValue, watch, type Ref } from 'vue'
import { useTransition } from '@vueuse/core'
import { useReducedMotion } from './useReducedMotion'

export interface UseCountUpOptions {
  duration?: number
}

export function useCountUp(
  source: Ref<number> | (() => number),
  options?: UseCountUpOptions,
): Readonly<Ref<number>> {
  const reducedMotion = useReducedMotion()
  // Keep the animated difference at zero while disabled: VueUse does not
  // update its stored transition value for source changes during that time.
  const baseline = ref(0)
  watch([reducedMotion, () => toValue(source)], ([reduced, value]) => {
    if (reduced) baseline.value = value
  }, { immediate: true, flush: 'sync' })

  const difference = useTransition(() => toValue(source) - baseline.value, {
    duration: options?.duration ?? 600,
    transition: [0.2, 0.8, 0.2, 1],
    disabled: reducedMotion,
  })
  return computed(() => baseline.value + difference.value)
}
